import WhatsappBackground from "@/assets/login/5.svg";
import StepsImage from "@/assets/login/6.svg";
import MDBox from "@/components/atoms/MDBox";
import colors from "@/themes/base/colors";

const { gradients } = colors;

const LeftContent = () => {
  return (
    <MDBox position={"relative"} height={"100%"} sx={{ backgroundColor: gradients.dark.main }}>
      <MDBox
        style={{
          position: "absolute",
          top: "50%",
          right: "0",
          transform: "translate(40%, -50%)",
          height: "90%",
          width: "90%",
          zIndex: 1,
        }}
      >
        <img
          src={WhatsappBackground}
          alt="WhatsApp Background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </MDBox>

      <MDBox
        style={{
          position: "absolute",
          top: "50%",
          right: "60%",
          transform: "translate(40%, -50%)",
          height: "90%",
          width: "90%",
          zIndex: 2,
        }}
      >
        <img
          src={StepsImage}
          alt="Steps Image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </MDBox>
    </MDBox>
  );
};

export default LeftContent;
